"use client";

import React from "react";
import { ComponentConfig } from "@puckeditor/core";
import Link from "next/link";
import { businessData } from "@/data/business";

export interface FAQItem {
  q: string;
  a: string;
}

export interface FAQAccordionProps {
  heading?: string;
  faqs?: FAQItem[];
  showCtaLink?: boolean;
}

export const FAQAccordionBlock: ComponentConfig<FAQAccordionProps> = {
  label: "FAQ Accordion Section",
  fields: {
    heading: { type: "text", label: "Section Heading" },
    showCtaLink: { type: "radio", label: "Show Link to Full FAQ", options: [{ label: "Yes", value: true }, { label: "No", value: false }] },
    faqs: {
      type: "array",
      getItemSummary: (faq: any) => faq.q || "Question",
      arrayFields: {
        q: { type: "text", label: "Question" },
        a: { type: "textarea", label: "Answer" },
      },
      defaultItemProps: {
        q: "What should a brand confirm before requesting samples?",
        a: "Share the intended user, product format, target actives, sensory direction, pack size, target market, estimated batch quantity, and any fixed ingredient or claim requirements.",
      },
    },
  },
  defaultProps: {
    heading: "Frequently Asked Questions",
    showCtaLink: true,
    faqs: businessData.faqs,
  },
  render: ({ heading, faqs, showCtaLink = true }) => {
    const list = faqs && faqs.length > 0 ? faqs : businessData.faqs;

    return (
      <section className="sec sec-alt" id="faq">
        <div className="container faq-wrap">
          <div className="sec-head">
            <h2>{heading}</h2>
          </div>

          {list.map((item, idx) => (
            <details className="faq" data-animate key={idx}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}

          {showCtaLink && (
            <p className="sec-cta">
              <Link href="/faq">
                See all technical FAQs{" "}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
            </p>
          )}
        </div>
      </section>
    );
  },
};
